import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_application.svg'


const _withScopeId = n => (_pushScopeId("data-v-009b88de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "content-page" }
const _hoisted_3 = { class: "help-text license-help-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "help-text" }
const _hoisted_7 = { class: "crm-card" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "logo",
  height: "16"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_crm_navbar = _resolveComponent("crm-navbar")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_crm_business_preview = _resolveComponent("crm-business-preview")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (!_ctx.isLicenseLevelValid)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.$t("LicenseLevel.DisabledInEssentialText1")) + " ", 1),
              _hoisted_4,
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("LicenseLevel.DisabledInEssentialText2")), 1)
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createBlock(_component_el_container, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_header, { height: "40px" }, {
            default: _withCtx(() => [
              _createVNode(_component_crm_navbar, {
                title: _ctx.$t('BusinessEmail.Title')
              }, null, 8, ["title"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("BusinessEmail.HelpText")), 1),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.searchText,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                  placeholder: _ctx.$t('BusinessEmail.SearchPlaceholder'),
                  clearable: "",
                  onInput: _ctx.debounceSearch
                }, null, 8, ["modelValue", "placeholder", "onInput"]),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessList, (b) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: b.id,
                      class: _normalizeClass({ 'checked-item': _ctx.associatedBusinessesIds.includes(b.id) })
                    }, [
                      _createVNode(_component_crm_business_preview, {
                        business: b,
                        "is-linked": _ctx.associatedBusinessesIds.includes(b.id),
                        onLinkToBusiness: ($event: any) => (_ctx.associateCurrentEmailToBusiness(b.id)),
                        onNavigateToMobiCRM: ($event: any) => (_ctx.navigateToBusinessUrl(b.url))
                      }, null, 8, ["business", "is-linked", "onLinkToBusiness", "onNavigateToMobiCRM"])
                    ], 2))
                  }), 128)),
                  (_ctx.associatedBusinesses.length > 0)
                    ? (_openBlock(), _createElementBlock("h1", _hoisted_8, _toDisplayString(_ctx.$t("BusinessEmail.AssociatedBusinessLabel")), 1))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associatedBusinesses, (b) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: b.id,
                      class: "checked-item"
                    }, [
                      _createVNode(_component_crm_business_preview, {
                        business: b,
                        "is-linked": true,
                        onNavigateToMobiCRM: ($event: any) => (_ctx.navigateToBusinessUrl(b.url))
                      }, null, 8, ["business", "onNavigateToMobiCRM"])
                    ]))
                  }), 128))
                ])
              ])), [
                [_directive_loading, _ctx.isLoading]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_footer, null, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}